import { Space } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import InfoCard from './components/InfoCard';
import TimeKeepingSalaryTable from './components/TimeKeepingSalaryTable';

import { useAppSelector } from 'app/store';
import HeaderPage from 'common/components/HeaderPage';
import roles, { getPermission } from 'configs/roles';

const SalaryPeriodDetail = () => {
  const { t } = useTranslation();
  const rolesUser = useAppSelector((state) => state.auth.roles);

  return (
    <>
      <HeaderPage
        fixed
        title={t('salary.timeKeepingProgram')}
      />
      <div className="t-mainlayout_wrapper">
        <Space
          direction="vertical"
          size={24}
          style={{ width: '100%' }}
        >
          <InfoCard />
          {
            getPermission(rolesUser, roles.APPROVE_SALARY_APPROVE_INDEX) && (
              <TimeKeepingSalaryTable />
            )
          }
        </Space>
      </div>
    </>
  );
};

export default SalaryPeriodDetail;
